import { forwardRef, type Ref, type SVGProps } from "react";
const IconPanorama360FilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29.81 8.207A4.35 4.35 0 0 0 28 6.427 15 15 0 0 0 24.37 5c-.365-.1-.75-.188-1.145-.277a1 1 0 0 0-1.2.749A1 1 0 0 0 22 5.7v5.82a31 31 0 0 1-3.24.38c-.06 0-.11.01-.17.01-.32.02-.64.04-.97.05-.53.03-1.06.04-1.62.04s-1.09-.01-1.62-.04c-.33-.01-.65-.03-.97-.05-.06 0-.11-.01-.17-.01a30 30 0 0 1-3.24-.41V5.7a1 1 0 0 0-1-1 1 1 0 0 0-.228.025Q8.185 4.85 7.63 5A15 15 0 0 0 4 6.427a4.35 4.35 0 0 0-1.81 1.78A2 2 0 0 0 2 9v14.6a1 1 0 0 0 .317.732 11.2 11.2 0 0 0 3.823 2.185l9.15-9.15a.99.99 0 0 1 1.4-.02l.02.02 2.29 2.29 3.29-3.29a.99.99 0 0 1 1.4-.02l.02.02 6.29 6.29V9a2 2 0 0 0-.19-.793M4.01 9C4.2 8.52 5.55 7.65 8 6.97v4.06C5.55 10.347 4.2 9.477 4.01 9M8 18.907A1.906 1.906 0 1 1 9.91 17 1.906 1.906 0 0 1 8 18.907m16-7.88v-4.06c2.45.68 3.8 1.55 3.99 2.03-.19.48-1.54 1.35-3.99 2.03" />
    <path d="M29.24 24.717C27.79 25.867 24.03 28 16 28a32.5 32.5 0 0 1-7.69-.82L16 19.487l3.29 3.29a1 1 0 1 0 1.42-1.41l-.3-.3 2.59-2.58Z" />
  </svg>
);
const ForwardRef = forwardRef(IconPanorama360FilledSVG);
ForwardRef.displayName = "IconPanorama360Filled";
export { ForwardRef as IconPanorama360Filled };
